import { all, fork } from "redux-saga/effects";
import playerprofile from "./playerprofile";
import dashboard from "./dashboard";

export default function* rootSaga() {
  yield all([
    fork(playerprofile),
    fork(dashboard),
  ]);
}
